import { atom } from "jotai";

export const sidebarOpenAtom = atom<boolean>(false);

export const toggleSidebarAtom = atom(null, (get, set) => {
  set(sidebarOpenAtom, (x) => !x);
});
